import { render, staticRenderFns } from "./persona-container.vue?vue&type=template&id=1addff9b&scoped=true&"
import script from "./persona-container.vue?vue&type=script&lang=ts&"
export * from "./persona-container.vue?vue&type=script&lang=ts&"
import style0 from "./persona-container.vue?vue&type=style&index=0&id=1addff9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1addff9b",
  null
  
)

export default component.exports